import React from 'react';
import './app-header.css';
import { number, func } from 'prop-types';

const AppHeader = ({ completed, allTasks, tasksQuantity }) => (
  <div className="app-header">
    <h1>{allTasks} {tasksQuantity()}, из них выполнено {completed}</h1>
  </div>
)

AppHeader.propTypes = {
  completed: number,
  tasksQuantity: func,
  allTasks: number,
}

AppHeader.defaultProps = {
  tasksQuantity: () => 'задачи',
  completed: 0,
  allTasks: 3
}

export default AppHeader